import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FixTransactionBetService } from 'src/app/apis/fix-transaction-bet.service';
import { MemberService } from 'src/app/apis/member.service';
import { ReportWinloseService } from 'src/app/apis/report-winlose.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { alertConfirm, alertSuccess } from 'src/app/utils/functions/alert';
import md5 from 'md5';
@Component({
  selector: 'app-winlose-detail-slot',
  templateUrl: './winlose-detail-slot.component.html',
  styleUrls: ['./winlose-detail-slot.component.scss'],
})
export class WinloseDetailSlotComponent extends AppCore implements OnInit {
  @Input() betId: string;
  @Input() currency: string = 'THB';
  @Input() gameType: string;

  loadingWinlose = false;
  data: any[] = [];
  tnxtId: string;

  url: any;

  summary = {
    amount: 0,
    wl: 0,
    bonus: 0,
  };

  constructor(
    private svMember: MemberService,
    private sanitizer: DomSanitizer,
    private svReportWinlose: ReportWinloseService,
    private svFix: FixTransactionBetService
  ) {
    super();
  }
  ngOnInit() {
    this.getBetDetail();
  }
  onBackToWinLoseDetail() {
    this.svReportWinlose.$onBackFromDetail.next();
  }
  getBetDetail() {
    this.summary.amount = 0;
    this.summary.wl = 0;
    this.summary.bonus = 0;
    this.loadingWinlose = true;
    this.svMember.getWinloseDetailGame(this.betId, this.gameType).subscribe(
      (res: any[]) => {
        this.data = res;
        this.data.forEach((element) => {
          if (element.winloseAmount != 0) {
            if (!element.isFreeRound) {
              this.summary.amount += element.betAmount;
              this.summary.wl += element.winloseAmount || 0;
            }
          }
          if (element.isFreeRound) {
            this.summary.bonus += element.winloseAmount;
          }
        });
        this.loadingWinlose = false;
      },
      (err) => {
        this.loadingWinlose = false;
      }
    );
  }
  fixMakeBetCancel(data: any) {
    alertConfirm({ html: `คุณต้องการยกเลิก TXNID : <b>${data.txnId}</b> หรือไม่?` }).then((c) => {
      if (c.isConfirmed) {
        this.svFix
          .makeCannelBet({
            game_type: 'slot',
            username: data.username,
            betId: data.betId,
            txnId: data.txnId,
            roundId: data.roundId,
          })
          .subscribe(() => {
            alertSuccess({ message: 'cancel bet success ' + data.txnId });
            this.getBetDetail();
          });
      }
    });
  }
  getReplay(data: any) {
    this.url = '';
    this.svMember
      .getBetReplay({
        productId: data.product_id,
        txnId_or_betId: data.txnId,
        username: data.username,
        roundId_or_parentBetId: data.roundId,
        gameCode: data.game_code,
        currency: this.currentAgent.currency,
        version_v2: false,
      })
      .subscribe((res: any) => {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
      });
  }

  getColorRoundId(item: any) {
    if (item.product_id == 'PGSOFT' || item.product_id == 'PGSOFT_NEW') {
      var roundId = item.roundId?.split('-')[1] || item.roundId;
      var color = roundId.substring(roundId.length - 6, roundId.length);
      return color;
    } else {
      var roundId = md5(item.roundId || '');
      var color = roundId.substring(roundId.length - 6, roundId.length);
      return color;
    }
  }
}
